var _path, _path2, _path3, _circle, _circle2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.4222 2.29689 14.7751 2.83209 16",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H20C18.8954 10 18 10.8954 18 12V14C18 15.1046 18.8954 16 20 16H21",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10H4C5.10457 10 6 10.8954 6 12V14C6 15.1046 5.10457 16 4 16H3",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12,
    r: 1,
    fill: "#888896"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 1,
    fill: "#888896"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 20.5,
    width: 2,
    height: 2,
    rx: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiry);
export default __webpack_public_path__ + "static/media/inquiry.9d2207c97a0eb13d046c94894b93b557.svg";
export { ForwardRef as ReactComponent };